import SettingsScreen from "@/components/bookmark";


export default function Bookmarks() {
  return <SettingsScreen />;
}
